import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rtFileSize',
  standalone: true,
})
export class FileSizePipe implements PipeTransform {
  private readonly ORDERED_SUFIXES = ['B', 'KB', 'MB', 'GB', 'TB'];

  public transform(size: number): string {
    return this.getFileSize(size);
  }

  private getFileSize(size: number, iter = 0): string {
    if (size < 1024) return `${size.toFixed(2)} ${this.ORDERED_SUFIXES[iter]}`;
    return this.getFileSize(size / 1024, iter + 1);
  }
}
